/**
 * Copyright(c) 2024 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @module Automation
 *
 * @author Naseef O
 */

export const htmlAttribute: string = "a-id";
export const automationIdKeySeparator: string = "-";
export const isAutomationEnabled: boolean = process.env.ENABLE_AUTOMATION_IDS ? JSON.parse(process.env.ENABLE_AUTOMATION_IDS) : false;

/**
 * @description This function is used to construct a-id
 *
 * @param {string[]} items
 * @return {*}  {{ [key: string]: string }}
 */
export const automationHandler = (items: string[]): { [key: string]: string } => {
  if (isAutomationEnabled) {
    return items?.length > 0 ? { [htmlAttribute]: ["m", ...items].filter((a) => !!a).join(automationIdKeySeparator) } : {};
  }
  return {};
};

/**
 * @description This function is used to construct a-id
 *
 * @return {*}
 */
export const automationConstants: { [key: string]: string } = {
  PLP: "plp",
  CLP: "clp",
  BLP: "blp",
  HOME: "h",
  PDP: "pdp",
  CART: "cart",
  CHECKOUT: "checkout",
  WISHLIST: "wishlist",
  BRANDS: "brands",
  MY_ACCOUNT_WISHLIST: "myAccountWishlist",
  FIND_STORE: "findStore",
  ORDER_CONFIRMATION: "orderConfirmation",
};
